import React, { useEffect, useRef, useState } from "react";
import { STATS } from "../mock";

function Counter({ value, suffix, trigger }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!trigger) return;
    const start = performance.now(); const dur = 1800;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.floor(eased * value));
      if (p < 1) requestAnimationFrame(tick); else setN(value);
    };
    requestAnimationFrame(tick);
  }, [trigger, value]);
  return <span className="stat-num">{n}{suffix}</span>;
}

export default function StatsLine() {
  const ref = useRef(null);
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const io = new IntersectionObserver((entries) => entries.forEach((e) => e.isIntersecting && setOn(true)), { threshold: 0.35 });
    io.observe(el); return () => io.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-bone border-y border-line">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <div key={i} className={`py-8 px-4 lg:px-8 ${i !== 0 ? "lg:border-l border-line" : ""} ${i === 2 ? "lg:border-l border-line" : ""}`}>
            <div className="font-display-tight text-6xl lg:text-8xl text-ink leading-none mb-3">
              <Counter value={s.value} suffix={s.suffix} trigger={on} />
            </div>
            <div className="text-eyebrow text-ink/55">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
